<template>
  <div class="layout">
    <NavigationBar/>
    <!-- <HeroSection />
    <AboutSection />
    <TalentDiagnosisSection />
    <ExperiencesSection /> -->
    <RouterView></RouterView>
    <FooterBar />
  </div>
</template>

<script>
import NavigationBar from './components/Navbar.vue';
// import HeroSection from './components/HeroSection.vue';
// import AboutSection from './components/AboutSection.vue';
// import TalentDiagnosisSection from './components/TalentDiagnosisSection.vue';
// import ExperiencesSection from './components/ExperiencesSection.vue';
import FooterBar from './components/Home/FooterBar.vue';

export default {
  name: 'App',
  components: {
    NavigationBar,
    // HeroSection,
    // AboutSection,
    // TalentDiagnosisSection,
    // ExperiencesSection,
    FooterBar
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,600;1,600&display=swap');

.layout {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  background-color: #000;
  font-family: "Open Sans", sans-serif;
}
</style>

